import { useEffect, useState, useTransition } from "react"
import { ModuleEnum, useLazyGetUtilitiesQuery } from "src/api/modules/utilitize"
import InputAutocomplete from "src/shared/components/input-autocomplete"

interface SelectDescriptionFieldProps {
  value: string
  onChange: (value: string, valueObj: any) => void
  label?: string
  fullWidth?: boolean
  placeholder?: string
  required?: boolean
  helperText?: string
  error?: boolean
  disableClearable?: boolean
}

const SelectDescriptionField = ({
  value,
  onChange,
  label,
  placeholder,
  fullWidth = true,
  required = false,
  helperText,
  disableClearable = false,
  error
}: SelectDescriptionFieldProps) => {
  const [isDescriptionPending, startDescriptionTransition] = useTransition()
  const [description, setDescription] = useState<IOptions[]>([])

  const [getUtilities] = useLazyGetUtilitiesQuery()
  const handleGetDescription = async () => {
    startDescriptionTransition(async () => {
      const response = await getUtilities({
        page: 1,
        limit: 10000,
        active: true,
        module: ModuleEnum.DESCRIPTION
      })
      startDescriptionTransition(() => {
        setDescription(
          response.data?.data?.map(item => ({
            value: item.id ?? "",
            label: item.itemName ?? ""
          })) ?? []
        )
      })
    })
  }

  useEffect(() => {
    if (value && !description.length) {
      handleGetDescription()
    }
  }, [value])

  return (
    <InputAutocomplete
      label={label}
      loading={isDescriptionPending}
      fullWidth={fullWidth}
      loadingText="Loading Description..."
      options={description}
      getOptionLabel={item => item.label ?? ""}
      getOptionKey={item => item.value ?? ""}
      onOpen={() => !description.length && handleGetDescription()}
      value={description.find(item => item.value === value)}
      placeholder={placeholder}
      onChange={(value: any) => {
        onChange(value?.value, value)
      }}
      required={required}
      helperText={helperText}
      error={error}
      disableClearable={disableClearable}
    />
  )
}

export default SelectDescriptionField
